import styled, { css } from 'styled-components';
import media from '../../../utils/styling/media';

type Props = {
  nopadding?: boolean;
  minButtonWidth?: number;
  flexButtonsXs?: boolean;
  buttonFlexGrow?: number | string;
};

export const StyledBar = styled.div<Props>`
  display: flex;
  margin: ${({ theme }) => theme?.ActionBar?.margin};
  padding: ${({ nopadding }) => nopadding ? '' : '16px 0 0 0'};
  flex-wrap: wrap;

  > * {
    flex-grow: ${({ theme, buttonFlexGrow }) => (typeof buttonFlexGrow !== 'undefined') ? buttonFlexGrow : theme?.ActionBar?.buttonFlexGrow};
    flex-shrink: 0;
    justify-content: space-between;
    margin: ${({ theme }) => theme?.ActionBar?.buttonMargin};
    flex-basis: ${({ theme, minButtonWidth }) => `${minButtonWidth || theme?.ActionBar?.minButtonWidth}px`};
  }

  ${({ flexButtonsXs }) => flexButtonsXs && css`
    ${media.xs`
      > * {
          flex: 1;
          min-width: calc(100% - 32px);
        }
    `}

    ${media.sm<Props>`
      > * {
        flex-grow: ${({ theme, buttonFlexGrow }) => (typeof buttonFlexGrow !== 'undefined') ? buttonFlexGrow : theme?.ActionBar?.buttonFlexGrow};
        flex-shrink: 0;
        flex-basis: ${({ theme, minButtonWidth }) => `${minButtonWidth || theme?.ActionBar?.minButtonWidth}px`};
        min-width: auto;
      }
    `}
  `}
`;
